import React from 'react'
import injectSheet from 'react-jss'
import CTAPromptTypes from 'aria-viewer/tour/constants/CTAPromptTypes'
import colors from 'aria-viewer/tour/constants/style/colors'
import CTAButtons from './CTAButtons'
import CLOSE_ICON from 'public/assets/svg/close-button.svg'
import YV_LOGO from 'public/assets/svg/yv_logo.svg'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

// Strings strings used in each prompt type to quickly ref
const TitleCopyStrings = {
    [CTAPromptTypes.ACT_NOW]: 'Act Now',
    [CTAPromptTypes.WHATS_NEXT]: `What's Next`,
}

const styleSheet = {
    container: {
        position: 'absolute',
        left: '0',
        top: '0',
        right: '0',
        bottom: '0',
        backgroundColor: 'rgba(8,19,30, 0.98)',
        color: colors.white,
        display: 'flex',
        flexDirection: 'column',
    },
    topSegment: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        flexBasis: '20%',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    middleSegment: {
        flexBasis: '60%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    bottomSegment: {
        flexBasis: '20%',
    },
    closeButton: {
        margin: '24px',
        position: 'absolute',
        top: '2px',
        right: '2px',
        cursor: 'pointer',
        width: '16px',
        height: '16px',
        zIndex: 1, //needed to show above other content
        '@media screen and (orientation: landscape)': {
            top: 48,
            right: 48,
        },
    },
    closeButtonSVG: {
        width: '100%',
        height: '100%',
    },
    ctaButtonArea: {
        position: ({ isDeviceMobile }) => (isDeviceMobile ? 'relative' : undefined),
        top: ({ isDeviceMobile }) => (isDeviceMobile ? '20%' : undefined),
        width: ({ isDeviceMobile }) => (isDeviceMobile ? '100%' : ''),
    },
    titleText: {
        fontSize: ({ isDeviceMobile }) => (isDeviceMobile ? '24px' : '22px'),
        textTransform: 'uppercase',
        paddingBottom: ({ isDeviceMobile }) => (isDeviceMobile ? '0.1em' : '0'),
        position: 'relative',
        top: ({ isDeviceMobile }) => (!isDeviceMobile ? '15%' : '2em'),
    },
    blueLine: {
        position: 'relative',
        width: ({ isDeviceMobile }) => (!isDeviceMobile ? '2.35em' : '4em'),
        height: ({ isDeviceMobile }) => (isDeviceMobile ? '0.23em' : '0.2em'),
        bottom: ({ isDeviceMobile }) => (!isDeviceMobile ? '-15%' : '-2.4em'),
        display: 'inline-block',
        background: colors.lightBlue,
    },
    poweredByYV: {
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        bottom: '1em',
        width: '100%',
    },
    poweredByText: {
        alignItems: 'flex-end',
        fontSize: '8pt',
        position: 'relative',
        top: '0.15em',
        marginTop: '0',
        marginBottom: '0',
        marginRight: '0.15em',
    },
    youvisitLogo: {
        alignItems: 'flex-start',
        width: '6.75em',
        height: 'auto',
    },
}

const CTAPrompt = ({ classes, ctaPromptType, isDeviceMobile, isModal, onClose, onKeyPress, onClickCloseButton }) => {
    return (
        <div id="act_now_modal" className={classes.container}>
            <div className={classes.topSegment}>
                <p
                    className={classes.titleText}
                    aria-label={(TitleCopyStrings[ctaPromptType] || 'Unknown Prompt Type') + ' prompt presented'}
                    aria-live="assertive"
                >
                    {TitleCopyStrings[ctaPromptType] || 'Unknown Prompt Type'}
                </p>
                <div className={classes.blueLine} />
            </div>
            <div className={classes.middleSegment}>
                <div className={classes.ctaButtonArea}>
                    <CTAButtons
                        isDeviceMobile={isDeviceMobile}
                        ctaPromptIsModal={isModal}
                        exitCTAPromptLogic={onClose}
                    />
                </div>
            </div>
            <div className={classes.bottomSegment}>
                {isDeviceMobile && (
                    <div className={classes.poweredByYV}>
                        <p className={classes.poweredByText}>Powered by</p>
                        <img className={classes.youvisitLogo} src={YV_LOGO} />
                    </div>
                )}
            </div>
            <div
                className={classes.closeButton}
                onClick={onClickCloseButton}
                onKeyPress={onKeyPress}
                tabIndex="0"
                role="button"
                alt="close prompt"
            >
                <img src={CLOSE_ICON} className={classes.closeButtonSVG} tabIndex="-1" />
            </div>
            <div className="accesibilityLastItem" tabIndex="0" role="button" alt="Jumping to top of Act Now Prompt" />
        </div>
    )
}

export default compose(
    injectSheet(styleSheet),
    pure
)(CTAPrompt)
